import { View } from "../../Core";
import Vue from "vue";
import { } from '@types/googlemaps';
import CollapsibleBlock from "../../Components/CollapsibleBlock/CollapsibleBlock.vue";


export class FaqView extends View<FaqView> {

    public constructor() {
        super();
        this.SetupVue();
    }

    SetupVue() {
        let v = new Vue({
            el: ".app",
            data: {},
            components: {
                CollapsibleBlock
            }
        });
    }
}


// WEBPACK FOOTER //
// ./www/js/Pages/Home/FaqView.ts